<div class="bc-email-outgoing-header" *ngIf="model">

  <div class="bc-email-outgoing-header-form" [attr.data-automation-id]="'bc-email-outgoing-header-form'">
    <h3 class="bc-panel-title">{{ 'bcEmailOutgoingHeader.panelTitle' | translate }}</h3>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'bcEmailOutgoingHeader.fromLabel' | translate }}</label>
      <app-dropdown [dropdownId]="'bc-email-from'" [items]="model.from.items" (selectedItemChange)="_onFromAddressChange($event)"></app-dropdown>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <div class="bc-label-row clearfix bc-form-required">
        <label class="bc-label bc-truncate">{{ 'bcEmailOutgoingHeader.toLabel' | translate }}</label>
        <span class="bc-label bc-label-required">{{ 'bcEmailOutgoingHeader.requiredLabel' | translate }}</span>
      </div>
      <input class="bc-input" type="text" [ngModel]="model.to"
             (ngModelChange)="validateEmail($event, emailAddressType.to)"
             [ngModelOptions]="{updateOn: 'blur'}"
             [ngClass]="{'bc-validation-error-input': toFieldHasChanged && model.emailToInvalid}"
             data-automation-id="bc-email-to" />
      <span class='bc-span bc-validation-error-text js-error-email-to'
            *ngIf="toFieldHasChanged && model.emailToInvalid"
            [innerText]="'bcEmailOutgoingHeader.invalidToEmailMessage' | translate: { invalidToEmailMessage: translateParams.invalidToEmailMessage }"
            data-automation-id="bc-email-to-error-msg"></span>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'bcEmailOutgoingHeader.ccLabel' | translate }}</label>
      <input class="bc-input"
             type="text"
             [ngModel]="model.cc"
             (ngModelChange)="validateEmail($event, emailAddressType.cc)"
             [ngModelOptions]="{updateOn: 'blur'}"
             [ngClass]="{'bc-validation-error-input': model.emailCcInvalid}"
             [attr.data-automation-id]="'bc-outgoing-header-cc-input'"/>
      <span class='bc-span bc-validation-error-text js-error-email-cc'
            *ngIf="model.emailCcInvalid"
            [innerText]="'bcEmailOutgoingHeader.invalidCcEmailMessage' | translate: { invalidCcEmailMessage: translateParams.invalidCcEmailMessage }"
            [attr.data-automation-id]="'bc-outgoing-header-cc-error'"></span>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'bcEmailOutgoingHeader.bccLabel' | translate }}</label>
      <input class="bc-input"
             type="text"
             [ngModel]="model.bcc"
             (ngModelChange)="validateEmail($event, emailAddressType.bcc)"
             [ngModelOptions]="{updateOn: 'blur'}"
             [ngClass]="{'bc-validation-error-input': model.emailBccInvalid}"
             [attr.data-automation-id]="'bc-outgoing-header-bcc-input'"/>
      <span class='bc-span bc-validation-error-text js-error-email-bcc'
            *ngIf="model.emailBccInvalid"
            [innerText]="'bcEmailOutgoingHeader.invalidBccEmailMessage' | translate: { invalidBccEmailMessage: translateParams.invalidBccEmailMessage }"
            [attr.data-automation-id]="'bc-outgoing-header-bcc-error'"></span>
    </div>

    <div class="bc-form-row bc-form-row-inline clearfix">
      <label class="bc-label bc-truncate">{{ 'bcEmailOutgoingHeader.subjectLabel' | translate }}</label>
      <input class="bc-input"
             type="text"
             [(ngModel)]="model.subject"
             [attr.data-automation-id]="'bc-outgoing-header-subject-input'"/>
    </div>
  </div>

  <div class="bc-actions clearfix">
    <button (click)="_save()"
            class="btn btn-dark js-save-header-button"
            [disabled]="model.emailToInvalid || model.emailCcInvalid || model.emailBccInvalid"
            [attr.data-automation-id]="'bc-outgoing-header-save-button'">
      <span>{{ 'bcEmailOutgoingHeader.saveButtonText' | translate }}</span>
    </button>

    <button (click)="_cancel()"
            class="btn btn-light js-cancel-header-button"
            [attr.data-automation-id]="'bc-outgoing-header-cancel-button'">
      <span>{{ 'bcEmailOutgoingHeader.cancelButtonText' | translate }}</span>
    </button>
  </div>
</div>
